import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: { loadPath: '/locales/{{lng}}.json' },
    cleanCode: true,
    detection: {
      caches: ['localStorage'],
      order: ['querystring', 'navigator', 'localStorage', 'htmlTag'],
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    supportedLngs: ['en', 'es', 'pt', 'ru'],
  });

export default i18n;
